import React from "react";
import {
	Box,
	Container,
	Typography,
	Grid,
	Paper,
	Link,
	Divider,
} from "@mui/material";
import company from "../assets/companyimg.jpg";
import whychooseus from "../assets/chooseusnow.jpg";
import regulatory from "../assets/newreg.jpg";
import securetrading from "../assets/sec.jpg";
import workers from "../assets/workers.jpeg";
import career from "../assets/newcareer.jpg";
import abtus from "../assets/abtus.jpg";

// Sample images for each section (replace with actual images)
const images = {
	whoWeAre: company,
	whyChooseUs: whychooseus,
	regulatory: regulatory,
	secureTrading: securetrading,
	careers: career,
	newsroom: workers,
};

// Section component for each topic
const Section = ({ title, content, image, reverse }) => (
	<Box sx={{ py: 6 }}>
		<Container maxWidth="lg">
			<Grid
				container
				spacing={4}
				alignItems="center"
				direction={reverse ? "row-reverse" : "row"}>
				<Grid item xs={12} md={6}>
					<Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
						{title}
					</Typography>
					{content.map((para, index) => (
						<Typography key={index} variant="body1" paragraph sx={{ mb: 2 }}>
							{para}
						</Typography>
					))}
					{/* Optional: add links for "Careers" or "Newsroom" */}
				</Grid>
				<Grid item xs={12} md={6}>
					<Box
						component="img"
						src={image}
						alt={title}
						sx={{
							width: "100%",
							height: "auto",
							borderRadius: 2,
							boxShadow: 3,
						}}
					/>
				</Grid>
			</Grid>
		</Container>
	</Box>
);

const AboutUsPage = () => {
	return (
		<Box>
			{/* Hero/Intro Section */}
			<Box
				sx={{
					bgcolor: "white",
					color: "black",
					py: 8,
					mt: "4rem",
					textAlign: "center",
					position: "relative",
				}}>
				<Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
					About Us
				</Typography>
				<Divider
					sx={{
						bgcolor: "white",
						my: "0.5rem",
						width: "5rem",
						marginX: "auto",
					}}
				/>
				<Typography
					variant="h6"
					sx={{
						maxWidth: 600,
						marginX: "auto",
						mb: "5rem",
						color: "#27282A",
					}}>
					Your trusted partner in crypto trading, committed to secure,
					responsible, and innovative financial solutions.
				</Typography>
				<div className="custom-shape-divider-bottom-1760305656  ">
					<svg
						data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 1200 120"
						preserveAspectRatio="none">
						<path
							d="M1200 0L0 0 892.25 114.72 1200 0z"
							class="shape-fill"></path>
					</svg>
				</div>
			</Box>

			{/* "Who We Are" Section */}
			<Section
				title="Who We Are"
				content={[
					"We are a leading cryptocurrency trading platform dedicated to providing seamless and secure trading experiences. Our team is passionate about blockchain technology and aims to empower traders worldwide with cutting-edge tools, reliable support, and transparency.",
				]}
				image={images.whoWeAre}
			/>

			{/* "Why Choose Us" Section */}
			<Section
				title="Why Choose Us"
				content={[
					"Our platform offers competitive fees, advanced trading features, and a user-friendly interface designed for both beginners and professional traders.",
					"We prioritize security, transparency, and customer satisfaction to ensure you trade with confidence.",
				]}
				image={images.whyChooseUs}
				reverse
			/>

			{/* "Regulatory Information" Section */}
			<Section
				title="Regulatory Information"
				content={[
					"We operate in compliance with all relevant financial regulations and hold necessary licenses to ensure your funds and data are protected.",
					"Our compliance team regularly monitors and updates our policies to meet the highest standards of regulatory requirements.",
				]}
				image={images.regulatory}
			/>

			{/* "Secure & Responsible Trading" Section */}
			<Section
				title="Secure & Responsible Trading"
				content={[
					"Security is at the heart of our platform. We use industry-leading encryption and security protocols to safeguard your assets.",
					"We promote responsible trading practices and provide tools to help manage risk effectively.",
				]}
				image={images.secureTrading}
				reverse
			/>

			{/* "Careers" Section */}
			<Section
				title="Careers"
				content={[
					"Join our dynamic team and be part of the future of crypto trading. We are always looking for talented professionals passionate about blockchain and finance.",
					"Explore our current openings and grow your career with us.",
				]}
				image={images.careers}
			/>

			{/* "Careers" Section */}
			<Section
				title="Newsroom"
				content={[
					"Stay updated with the latest news, updates, and insights from our platform and the crypto industry.",
					"Visit our newsroom regularly for press releases, blog posts, and announcements.",
				]}
				image={images.newsroom}
			/>

			{/* "Newsroom" Section */}
			{/* <Section
        title="Newsroom">
        content={[
          'Stay updated with the latest news, updates, and insights from our platform and the crypto industry.',
          'Visit our newsroom regularly for press releases, blog posts, and announcements.',
        ]}
        image={images.newsroom}
       
    /> */}
		</Box>
	);
};

export default AboutUsPage;
